import { c as _c } from "react/compiler-runtime";
import type { ProductFeedItem } from '__generated__/api/unauth/types.gen';
import { Divider } from '@common/components';
import { SvgHelpQuestionFill, SvgStarFill } from '@common/icon';
import { cn } from '@core/utils';
import type { MouseEvent } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES, WEL_MARKET_ROUTES } from '@/constants/routes';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { formatPrice } from '@/utils/formatPrice';
interface ProductCardProps {
  product: ProductFeedItem;
  onHelpQuestion: (e: MouseEvent) => void;
}
export const ProductCard = t0 => {
  const $ = _c(69);
  const {
    product,
    onHelpQuestion
  } = t0;
  const {
    productId,
    slugId,
    productName,
    mainImageUrl,
    price,
    review,
    tags,
    salePhase,
    soldOut,
    gov,
    giftProductNumber
  } = product;
  const isSoldOut = soldOut && salePhase === "ON_SALE";
  const isNotOnSale = salePhase !== "ON_SALE" && salePhase !== undefined || isSoldOut;
  const salePhaseLabel = isSoldOut ? "\uD488\uC808" : salePhase === "SALE_ENDED" ? "\uD310\uB9E4 \uC885\uB8CC" : "\uC0C1\uD488 \uC900\uBE44\uC911\uC774\uC5D0\uC694";
  const regularPrice = price?.regularPrice ?? 0;
  const expectedFinalPrice = price?.expectedFinalPrice ?? regularPrice;
  const discountRate = price?.totalDiscountRate ?? 0;
  const hasDiscount = expectedFinalPrice !== regularPrice;
  const priceColor = hasDiscount ? "text-Gray-550" : "text-Gray-black";
  let t1;
  if ($[0] !== productId || $[1] !== slugId) {
    t1 = WEL_MARKET_ROUTES.PRODUCT_DETAIL.pathname({
      productNumber: slugId ?? productId ?? ""
    });
    $[0] = productId;
    $[1] = slugId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== expectedFinalPrice || $[4] !== gov?.govName || $[5] !== productId || $[6] !== productName) {
    t2 = () => trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
      currency: "KRW",
      value: expectedFinalPrice,
      local_name: gov?.govName ?? "",
      items: [{
        item_type: "\uC6F0\uB9C8\uCF19\uC0C1\uD488",
        item_list_name: "\uC6F0\uB9C8\uCF19_\uC0C1\uD488\uD53C\uB4DC",
        item_list_id: "WM_FEED",
        price: expectedFinalPrice,
        item_name: productName ?? "",
        quantity: 1,
        item_id: productId ?? ""
      }]
    });
    $[3] = expectedFinalPrice;
    $[4] = gov?.govName;
    $[5] = productId;
    $[6] = productName;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== mainImageUrl || $[9] !== productName) {
    t3 = mainImageUrl ? <Image src={mainImageUrl} alt={productName ?? ""} fill={true} sizes="(max-width: 1279px) 50vw, 25vw" className="rounded-none object-cover" /> : <div className="absolute inset-0 bg-Gray-200" />;
    $[8] = mainImageUrl;
    $[9] = productName;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isNotOnSale || $[12] !== salePhaseLabel) {
    t4 = isNotOnSale && <div className="absolute inset-0 flex items-center justify-center bg-Gray-black/40"><p className="font-700 text-Gray-white typo-body2 mobile-tablet:typo-body3">{salePhaseLabel}</p></div>;
    $[11] = isNotOnSale;
    $[12] = salePhaseLabel;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className="relative aspect-square w-full overflow-hidden">{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== productName) {
    t6 = <p className="line-clamp-2 font-500 text-Gray-900 typo-body1 mobile-tablet:typo-body2">{productName}</p>;
    $[17] = productName;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== tags) {
    t7 = tags && tags.length > 0 && <div className="flex gap-4">{tags.map(_temp)}</div>;
    $[19] = tags;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <div className="flex flex-col gap-8 mobile-tablet:gap-4">{t6}{t7}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== priceColor) {
    t9 = cn("font-600 typo-body4", priceColor);
    $[24] = priceColor;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t9) {
    t10 = <span className={t9}>일반가</span>;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== priceColor) {
    t11 = cn("font-700 typo-body1 mobile-tablet:typo-body2", priceColor);
    $[28] = priceColor;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== regularPrice) {
    t12 = formatPrice(regularPrice);
    $[30] = regularPrice;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12) {
    t13 = <span className={t11}>{t12}</span>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t13) {
    t14 = <div className="flex flex-col gap-2">{t10}{t13}</div>;
    $[35] = t10;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== discountRate || $[39] !== expectedFinalPrice || $[40] !== hasDiscount) {
    t15 = hasDiscount && <><Divider variant="vertical" className="h-36 !bg-Gray-300" /><div className="flex flex-1 flex-col"><span className="font-600 text-Gray-black typo-body4">최대할인가</span><div className="flex items-center gap-4"><span className="font-700 text-Gray-black typo-body1 mobile-tablet:typo-body2">{formatPrice(expectedFinalPrice)}</span>{discountRate > 0 && <span className="font-700 text-R-400 typo-body1 mobile-tablet:typo-body2">{discountRate}%</span>}</div></div></>;
    $[38] = discountRate;
    $[39] = expectedFinalPrice;
    $[40] = hasDiscount;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SvgStarFill className="size-20 text-Y-550 mobile-tablet:size-14" />;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  const t17 = review?.averageRating ?? 0;
  let t18;
  if ($[43] !== t17) {
    t18 = <span className="font-700 text-Gray-600 typo-body3 mobile-tablet:typo-body4">{t17}</span>;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  const t19 = review?.reviewCount ?? 0;
  let t20;
  if ($[45] !== t19) {
    t20 = <span className="font-400 text-Gray-600 typo-body3 mobile-tablet:typo-body4">({t19})</span>;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t18 || $[48] !== t20) {
    t21 = <div className="ml-auto flex flex-col items-center gap-4">{t16}<div className="flex items-center gap-2">{t18}{t20}</div></div>;
    $[47] = t18;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t14 || $[51] !== t15 || $[52] !== t21) {
    t22 = <div className="flex items-center gap-20">{t14}{t15}{t21}</div>;
    $[50] = t14;
    $[51] = t15;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t22 || $[55] !== t8) {
    t23 = <div className="flex flex-col gap-24 px-8 mobile-tablet:gap-16">{t8}{t22}</div>;
    $[54] = t22;
    $[55] = t8;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t1 || $[58] !== t2 || $[59] !== t23 || $[60] !== t5) {
    t24 = <CustomLink href={t1} className="flex flex-col gap-20 mobile-tablet:gap-12" onClick={t2}>{t5}{t23}</CustomLink>;
    $[57] = t1;
    $[58] = t2;
    $[59] = t23;
    $[60] = t5;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== giftProductNumber || $[63] !== gov?.govName || $[64] !== onHelpQuestion) {
    t25 = giftProductNumber ? <CustomLink className="mt-24 flex items-center justify-center gap-12 border border-O-400 py-16 font-700 text-O-400 hover:opacity-80 mobile-tablet:mt-12" href={DONATION_ROUTES.GIFTS_DETAIL.withSearchParams({
      dynamicPath: {
        productNumber: giftProductNumber
      }
    })}>{gov?.govName}에 기부 시 0원<div className="flex" onClick={onHelpQuestion}><SvgHelpQuestionFill className="size-20" /></div></CustomLink> : null;
    $[62] = giftProductNumber;
    $[63] = gov?.govName;
    $[64] = onHelpQuestion;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== t24 || $[67] !== t25) {
    t26 = <div className="flex flex-col">{t24}{t25}</div>;
    $[66] = t24;
    $[67] = t25;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  return t26;
};
function _temp(tag, index) {
  return <span key={`${tag.tagCode}-${index}`} className="rounded-xsmall px-6 py-2 font-600 typo-caption1" style={{
    backgroundColor: tag.backgroundColor ?? undefined,
    color: tag.textColor ?? undefined
  }}>{tag.tagName}</span>;
}